import { IDriver } from 'apps/fleet-planner/types'

export const MODAL_ACTION_TYPES = {
  OPEN_DRIVER_OPT_IN_MODAL: 'OPEN_DRIVER_OPT_IN_MODAL',
  CLOSE_DRIVER_OPT_IN_MODAL: 'CLOSE_DRIVER_OPT_IN_MODAL',
  SHOW_SHARE_LOAD_TOAST: 'SHOW_SHARE_LOAD_TOAST',
  DISMISS_SHARE_LOAD_TOAST: 'DISMISS_SHARE_LOAD_TOAST',
}

export const openDriverOptInModal = (drivers: IDriver[]) => ({
  payload: { drivers },
  type: MODAL_ACTION_TYPES.OPEN_DRIVER_OPT_IN_MODAL,
})

export const showShareLoadToast = ({
  message,
  shipmentId,
}: {
  shipmentId: string
  message: string
}) => ({
  payload: { shipmentId, message },
  type: MODAL_ACTION_TYPES.SHOW_SHARE_LOAD_TOAST,
})

export const dismissShareLoadToast = () => ({ type: MODAL_ACTION_TYPES.DISMISS_SHARE_LOAD_TOAST })

export const closeDriverOptInModal = () => ({ type: MODAL_ACTION_TYPES.CLOSE_DRIVER_OPT_IN_MODAL })
